import RootStore from '@stores/RootStore';
import { Form } from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';

export default class BaseForm extends Form {
    constructor(hooks: any, fields: any, rootStore: RootStore) {
        const asyncRules = {
            checkUser: async (value: any, attr: any, key: string, passes: any) => {
                if (key === "emailAddress") {
                    const msg = `Email adresa je već zauzeta`;
                    var response = await rootStore.registrationStore.checkEmailAddressAsync(value);

                    response ? passes() : passes(false, msg)
                }
            }
        };

        super({ ...fields }, {
            plugins: {
                dvr: dvr({
                    package: validatorjs,
                    extend: ({ validator, form }: any) => {
                        // here we can access the `validatorjs` instance (plugin) and we
                        // can add the rules using the `registerAsyncRule()` method.

                        Object.keys(asyncRules).forEach((key) => {
                            validator.registerAsync(key, asyncRules[key as keyof typeof asyncRules])
                        })
                    }
                })
            },
            hooks,
            options: {
                validationDebounceWait: 10,
                validateOnBlur: true
            }
        })
    }
}